/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
import imagesLoaded from 'imagesloaded';

export function shareRecipe() {
  // show if a URL param exists
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const sharePreference = urlParams.get('share');

  if (location.search.indexOf('share=') >= 0 ) {
    $('.shareRecipeCTA').addClass('hidden');
    // scroll to the section
    imagesLoaded(document.querySelector('.featuredRecipes'), function (instance) {
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".bottomCTA").offset().top - 600
      }, 3000);
    });
  } else {
    $('.shareRecipe').hide();
  }

  $('.shareRecipeCTA').on('click tap', function() {
    $('.shareRecipe').slideDown();
    $(this).addClass('hidden');

    // Update the URL
    if (history.pushState) {
      history.pushState(null, null, "?share=recipe");
    } else {
      location.hash = "?share=recipe";
    }
  });

  $('.shareRecipe__close').on('click tap', function() {
    $('.shareRecipe').slideUp();
    setTimeout(() => {
      $('.shareRecipeCTA').removeClass('hidden');
    }, 500);
  });
}





